module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAyCAYAAAAweqkjAAAABGdBTUEAALGPC/xhBQAAAO9JREFUWAnt2UEKwjAUBND80GP0Qp5B6crqpt6mK3Hryeo5/BohkMUwTUFoFtNNw0ygn5ddY8M4Hd7B7u7ehwYeM3vF4JfY0lDJJQGlmbos9XzM1gBYOJ6n70jexxaGQTNoMKTCMokxHdRJDKmwTGJMB3USQyoskxjTQZ3EkArLJMZ0UCcxpMIyiTEd1EkMqbBMYkwHdRJDKiyTGNNBncSQCsskxnRQJzGkwrKOlblL/0Xz+l/vtX++Osqt0lVHuca+9aM1+3WUNUrlHomVGjVridUolXvsNN6WfANXFnuuf3eWFu2aFnsOUn47X6R+AAoXK/6Pf3CXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = JhOT
// module chunks = 1